jQuery(document).ready(function($){

    $('.form__label--checkbox, .wpcf7-list-item-label').click(function() {
        var $el = $(this).closest('.form__group--checkbox');
        $el.find('input[type="checkbox"]').trigger('click');
        $el.toggleClass('is-active');
    });

    var tense_templates = {
        'certificates': wp.template('info-certificates'),
        'experience': wp.template('info-experience'),
        'education': wp.template('info-education'),
        'languages': wp.template('info-languages'),
        'skills': wp.template('info-skills'),
        'pdf_preview': wp.template('pdf-content'),

    };

    $('.wpcf7-field-groups').on('click', '[data-group-add]' , function(event) {
        event.preventDefault();

        var $group = $(this).closest('.wpcf7-field-group');
        var slug = $(this).closest('.wpcf7-field-groups').data('wpcf7-group-id');
        var count = $group.find('.wpcf7-field-group-count').val();

        var fields = {};
        $group.find('input').each(function() {
            var name = $(this).attr('name');

            if ($(this).attr('type') == 'hidden' || name === undefined) {
                return;
            }
            name = name.replace(/__\d+$/, '');
            name = name.replace(/[\[\]]/, '');
            name = name.replace('your-', '');
            name = name.replace('-', '_');

            var field_val = $(this).attr('type') == 'checkbox' ? $(this).prop('checked') : $(this).val();
            if ((name.indexOf('_start') != -1) || (name.indexOf('_end') != -1)) {
                field_val = tense_date_format(field_val, 'short');
            } else if (name.indexOf('birthdate') != -1) {
                field_val = tense_date_format(field_val);
            }

            field_val = field_val !== undefined ? field_val : null;
            fields[name] = field_val;
        });

        fields['slug'] = slug;
        fields['count'] = count;

        if (slug in tense_templates) {
            var tmpl = tense_templates[slug];
            var content = tmpl(fields);

            if (content) {
                var $container = $('[data-group="' + slug + '"]');
                $container.append(content);
                var $add_btn = $group.find('.wpcf7-field-group-add');
                $add_btn.trigger('click');
                $group.hide();
            }
        }
    });

    $('.wpcf7').on('click', '[data-group-remove]' , function(event) {
        event.preventDefault();

        var count = $(this).data('group-remove');
        var slug = $(this).data('group-slug');
        var $group = $('.wpcf7-field-group-count[name="_wpcf7_groups_count[' + slug + ']__' + count  + '"]').closest('.wpcf7-field-group');
        var $remove_btn = $group.find('.wpcf7-field-group-remove');
        $remove_btn.trigger('click');
        var $row = $(this).closest('[data-group-row]');
        $row.remove();
    });

    $('.form__group.inline input').click(function(event) {
        event.stopPropagation();
    });

    $('[data-preview]').click(function(event) {
        event.preventDefault();

        var fields = {};
        $('.wpcf7').find('input, textarea').each(function() {
            var name = $(this).attr('name');

            if ($(this).attr('type') == 'hidden' || name === undefined) {
                return;
            }

            name = name.replace('your-', '');
            name = name.replace('-', '_');
            name = name.replace(/[\[\]]/g, '');
            var field_val = $(this).attr('type') == 'checkbox' ? $(this).prop('checked') : $(this).val();

            if (name == 'photo') {
                var $photo = $('.preview-img img');
                field_val = $photo ? $photo.attr('src') : null;
            } else if ((name.indexOf('_start') != -1) || (name.indexOf('_end') != -1)) {
                field_val = tense_date_format(field_val, 'short');
            } else if (name.indexOf('birthdate') != -1) {
                field_val = tense_date_format(field_val);
            }

            field_val = field_val !== undefined ? field_val : null;
            fields[name] = field_val;
        });

        var group_counts = {};

        $('.wpcf7').find('.wpcf7-field-group-count').each(function(index) {
            var name = $(this).attr('name');
            name = name.replace(/.*?\[/g, '');
            name = name.replace(/\].*?/g, '');
            name = name.replace(/__\d+/g, '');
            var count = $(this).val();
            group_counts[name] = parseInt(count);
        });

        function tense_get_groups(needles, group_name) {
            var count = group_name in group_counts ? group_counts[group_name] : 0;
            var out = [];

            for (var i = 1; i <= count; i++) {
                var arr = {};
                var valid = false;

                Object.keys(needles).forEach(function(key, index) {
                    var field_name = key + '__' + i;
                    var $el = $(':input[name="' + field_name + '"]');
                    var val = $el.length ? $el.eq(0).val() : false;
                    arr[needles[key]] = val;

                    if (val) {
                        valid = valid | true;
                    }
                });

                if (valid) {
                    out.push(arr);
                }
            }

            if (group_name == 'skills') {
                if (out) {
                    out.forEach(function(item, index) {
                        out[index] = item.skill;
                    });
                }

            }

            return out;
        }

        fields['experience'] = tense_get_groups(
            {
                'your-exp-start': 'date_start',
                'your-exp-end': 'date_end',
                'your-position': 'position',
                'your-company': 'company',
                'your-responsibility': 'responsibility',
            },
            'experience'
        );

        fields['education'] = tense_get_groups(
            {
                'your-education-start': 'date_start',
                'your-education-end': 'date_end',
                'your-school': 'school',
                'your-specialty': 'specialty',
                'your-education-description': 'description',
            },
            'education'
        );

        fields['languages'] = tense_get_groups(
            {
                'your-language': 'language',
                'your-language-level': 'level',
            },
            'languages'
        );

        fields['skills'] = tense_get_groups(
            {
                'your-skill': 'skill',
            },
            'skills'
        ).join(', ');

        fields['certificates'] = tense_get_groups(
            {
                'your-skill-date': 'date',
                'your-skill-name': 'name',
            },
            'certificates'
        );


        var pdf_preview = tense_templates['pdf_preview'];
        $('#pdf-preview-content').html(pdf_preview(fields));
        $('#pdf-preview').foundation('open');
    });

    function tense_num_to_roman(num) {
        num = parseInt(num);
        if (typeof num !== 'number') 
            return false; 

        var digits = String(+num).split(""),
            key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM", "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC","","I","II","III","IV","V","VI","VII","VIII","IX"],
            roman_num = "",
            i = 3;
        while (i--)
            roman_num = (key[+digits.pop() + (i * 10)] || "") + roman_num;
        return Array(+digits.join("") + 1).join("M") + roman_num;
    }

    function tense_date_format(date, format) {
        if (format === undefined) {
            format = "full";
        }

        var components = date.split('.');
        var out = date !== undefined ? date : '';

        if (format == 'short') {
            out = tense_num_to_roman(components[0]) + ' ' + components[1];
        } else if (components.length == 3) {
            out = components[0] + '.' + components[1] + '.' + components[2];
        }

        return out;
    }

    function tense_dnd_field(elem) {
        if ($(elem).length == 0 || typeof FileReader === "undefined")
            return;
        var $fileupload = $('input[type="file"]');
        var remove = '<div class="remove"><div class="close-button">&times;</div></div>'

        $fileupload.each(function () {
            var self = this;

            var $dropfield = $('<div class="drop-field"><div class="drop-area"><div class="preview-img"><span class="helptext">' + tense_vars.photo_caption + '</span><img src="" style="width:100%;"/></div></div></div>');
            $(self).after($dropfield).appendTo($dropfield.find('.drop-area'));
            $dropfield.append(remove);
            var $previewContainer = $('.preview-img img');
            var isDropped = false;
            var extensions = ['.png', '.jpg', 'jpeg'];
            $(self).on("change", function (event) {
                if ($(self).val() == "") {
                } else {
                    if (!isDropped) {
                        $dropfield.removeClass('hover');
                        $dropfield.addClass('loaded');
                        $('.form__group--first > .row').addClass('align-bottom');
                        var files = $(self).prop("files");
                        traverseFiles(files);
                    }
                }
            });

            $dropfield.on("dragleave", function (event) {
                $dropfield.removeClass('hover');
                event.stopPropagation();
            });

            $dropfield.on('click', function (event) {
                $(self).val('');
                $previewContainer.attr('src', '');
                $dropfield.removeClass('hover').removeClass('loaded');
                $('.form__group--first > .row').removeClass('align-bottom');
            });

            $dropfield.on("dragenter", function (event) {
                $dropfield.addClass('hover');
                event.stopPropagation();
            });

            $dropfield.on("drop", function (event) {
                isDropped = true;
                $dropfield.removeClass('hover');
                $dropfield.addClass('loaded');
                $('.form__group--first > .row').addClass('align-bottom');
                var files = event.originalEvent.dataTransfer.files;
                if (extensions.indexOf(files[0].name.substr(files[0].name.length - 4)) > -1) {
                    traverseFiles(files);
                    isDropped = false;
                } else {
                    alert('Rozszerzenie nieobsługiwane.');
                }

            });

            function _loadPreview(file, id) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $previewContainer.attr('src', e.target.result);
                }
                reader.readAsDataURL(file);
            }


            function appendFile(file, i) {
                var id = 'preview-img-' + i;
                _loadPreview(file, id);
            }

            function traverseFiles(files) {
                if ($dropfield.hasClass('loaded')) {
                    $previewContainer.attr('src', '');
                }
                if (typeof files !== "undefined") {
                    for (var i = 0, l = files.length; i < l; i++) {
                        appendFile(files[i], i);
                    }
                } else {
                    alert("Brak obsługi API");
                }
            }

        });
    }

    tense_dnd_field('.wpcf7 .your-photo input[type="file"]');

    $('.mask-postcode').inputmask('99-999', {
        placeholder: '00-000',
    });

    $('.mask-date-long').inputmask('99.99.9999', {
        placeholder: 'DD.MM.YYYY',
    });

    $('.mask-date-short').inputmask('99.9999', {
        placeholder: 'MM.YYYY',
    });

    $('body').on('wpcf7-field-groups/added', function() {
        $('.mask-date-short').inputmask('99.9999', {
            placeholder: 'MM.YYYY',
        });
    });

});
